import { observer } from 'mobx-react';
import React from 'react';
import { AGGREGATORS } from '~/constants/aggregators';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { localeStore } from '~/mobx/localesStore';
import { ButtonAppearance } from '~/view/components/Controls/ButtonComponent/types';
import CustomTooltip, { TOOLTIP_POSITION, TOOLTIP_TYPE } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { timeConfirmStore } from '~/view/containers/Modals/TimeConfirmModal/TimeConfirmStore';
import './style.scss';

interface IProps {
  integrationId: number;
  disabled: boolean;
}

const ToYouMatchBranchesButton: React.FC<IProps> = observer((props: IProps) => {
  if (props.integrationId !== AGGREGATORS.TO_YOU) {
    return null;
  }

  const handleClick = () => {
    timeConfirmStore.openTimeConfirmModalForFetchTakerAndToYouBranches();
  };

  return (
    <div id="toYouMatchBranchesButton" className="flex-row align-items-end justify-content-start to-you-match-branches-button hidden">
      {props.disabled ? (
        <CustomTooltip
          position={TOOLTIP_POSITION.FIXED}
          type={TOOLTIP_TYPE.INFO}
          message={localeStore.t('branch_matching_disabled_btn_text')}
          wrapperClassName="to-you-match-branches-tooltip"
        ></CustomTooltip>
      ) : null}
      <Button onClick={handleClick} disabled={props.disabled} appearance={ButtonAppearance.TERTIARY}>
        {localeStore.t('match_branches_btn')}
      </Button>
    </div>
  );
});

export default ToYouMatchBranchesButton;
